import { resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, Transition as _Transition } from "vue"
import _imports_0 from './assets/AnnularEclipseMap.png'
import _imports_1 from './assets/video.mp4'


const _hoisted_1 = { id: "non-map-container" }
const _hoisted_2 = {
  id: "title-row",
  class: "non-map-row"
}
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  id: "instructions-row",
  class: "non-map-row"
}
const _hoisted_8 = { id: "top-container-main-text" }
const _hoisted_9 = {
  key: 0,
  class: "instructions-text"
}
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "instructions-text"
}
const _hoisted_13 = { class: "description" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "my-1"
}
const _hoisted_16 = {
  key: 2,
  class: "instructions-text"
}
const _hoisted_17 = { class: "description" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  id: "button-row",
  class: "non-map-row"
}
const _hoisted_21 = { id: "top-container-buttons" }
const _hoisted_22 = { id: "map-column" }
const _hoisted_23 = {
  key: 0,
  id: "map-container"
}
const _hoisted_24 = {
  key: 1,
  id: "eclipse-path-map"
}
const _hoisted_25 = { class: "video-wrapper" }
const _hoisted_26 = { style: {"min-height":"120px"} }
const _hoisted_27 = { class: "text-list" }
const _hoisted_28 = { class: "text-list" }
const _hoisted_29 = { class: "switch-bullets" }
const _hoisted_30 = { class: "switch-bullets mb-3" }
const _hoisted_31 = { class: "switch-bullets" }
const _hoisted_32 = { class: "switch-bullets mb-5" }
const _hoisted_33 = { class: "text-list" }
const _hoisted_34 = { id: "main-content" }
const _hoisted_35 = { id: "first-splash-row" }
const _hoisted_36 = { id: "splash-screen-acknowledgements" }
const _hoisted_37 = { id: "splash-screen-logos" }
const _hoisted_38 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_39 = {
  key: 0,
  id: "introduction-overlay",
  class: "elevation-10"
}
const _hoisted_40 = { id: "intro-window-close-button" }
const _hoisted_41 = { class: "intro-text mb-3" }
const _hoisted_42 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_43 = { id: "intro-bottom-controls" }
const _hoisted_44 = { id: "top-wwt-content" }
const _hoisted_45 = { id: "location-date-display" }
const _hoisted_46 = { id: "top-switches" }
const _hoisted_47 = { id: "track-sun-switch" }
const _hoisted_48 = { class: "bottom-content" }
const _hoisted_49 = { id: "eclipse-percent-chip" }
const _hoisted_50 = {
  id: "controls",
  class: "control-icon-wrapper"
}
const _hoisted_51 = { id: "controls-top-row" }
const _hoisted_52 = {
  key: 0,
  id: "control-checkboxes"
}
const _hoisted_53 = { id: "video-icon" }
const _hoisted_54 = { id: "tools" }
const _hoisted_55 = { class: "tool-container" }
const _hoisted_56 = { id: "speed-control" }
const _hoisted_57 = { id: "speed-text" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { id: "change-optout" }
const _hoisted_62 = {
  key: 0,
  id: "body-logos"
}
const _hoisted_63 = { id: "user-experience-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_hover_tooltip = _resolveComponent("hover-tooltip")!
  const _component_image_label = _resolveComponent("image-label")!
  const _component_flip_transition = _resolveComponent("flip-transition")!
  const _component_mc_radiogroup = _resolveComponent("mc-radiogroup")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_location_selector = _resolveComponent("location-selector")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_gif_play_pause = _resolveComponent("gif-play-pause")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_geolocation_button = _resolveComponent("geolocation-button")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: "closed-top-container",
        class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
      }, [
        _createVNode(_component_font_awesome_icon, {
          modelValue: _ctx.showGuidedContent,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showGuidedContent) = $event)),
          class: _normalizeClass(_ctx.showGuidedContent ? 'ma-1' : ''),
          size: _ctx.showGuidedContent ? 'xl' : '2xl',
          color: _ctx.showGuidedContent ? 'var(--accent-color)' : 'black',
          icon: _ctx.showGuidedContent ? 'chevron-up' : 'circle-chevron-down',
          onClick: _cache[1] || (_cache[1] = () => {
        // console.log('showGuidedContent = ', showGuidedContent);
        _ctx.showGuidedContent = !_ctx.showGuidedContent;
        _ctx.onResize();
      }),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.showGuidedContent = !_ctx.showGuidedContent), ["enter"])),
          tabindex: "0",
          "tooltip-location": "start"
        }, null, 8, ["modelValue", "class", "size", "color", "icon"])
      ], 2),
      _withDirectives(_createVNode(_component_v_container, { id: "guided-content-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_hover_tooltip, {
            "tooltip-text": _ctx.scrollUp ? 'Scroll to top' : 'Scroll to bottom',
            disabled: _ctx.mobile,
            id: "scrollButton"
          }, {
            target: _withCtx(() => [
              (!_ctx.smAndUp)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    icon: _ctx.scrollUp ? 'mdi-arrow-up' : 'mdi-arrow-down',
                    onClick: _ctx.scrollToTop,
                    size: "small",
                    density: "comfortable",
                    color: _ctx.accentColor,
                    variant: "flat"
                  }, null, 8, ["icon", "onClick", "color"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["tooltip-text", "disabled"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.learnerPath=='Explore')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Watch and Compare "))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Answer')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Identify Eclipse Path "))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Choose')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Choose Any Location "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.learnerPath=='Explore')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        (!_ctx.queryData)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                              _cache[67] || (_cache[67] = _createTextVNode()),
                              _createVNode(_component_font_awesome_icon, {
                                icon: "play",
                                class: "bullet-icon"
                              }),
                              _cache[68] || (_cache[68] = _createTextVNode(" to \"watch\" the eclipse at the location marked by the red dot."))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " highlighted cities", 1),
                          _cache[69] || (_cache[69] = _createTextVNode(" on the map to switch locations and view the eclipse from there."))
                        ]),
                        _cache[70] || (_cache[70] = _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Explore"),
                          _createTextVNode(" until you can identify which locations will see an annular eclipse!")
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Answer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("p", null, [
                          _cache[71] || (_cache[71] = _createTextVNode("Have you determined the eclipse path? ")),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " a card", 1),
                          _cache[72] || (_cache[72] = _createTextVNode(" to select it."))
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode("If you are not sure, " + _toDisplayString(_ctx.touchscreen ? "tap" : "click") + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "rocket",
                            class: "bullet-icon"
                          }),
                          _cache[73] || (_cache[73] = _createTextVNode(" to keep exploring."))
                        ])
                      ]),
                      (_ctx.learnerPath=='Answer')
                        ? (_openBlock(), _createBlock(_component_mc_radiogroup, {
                            key: 0,
                            id: "mc-radiogroup-container",
                            row: "",
                            "hide-input": "",
                            preselected: _ctx.quizAnswer,
                            "radio-options": ['A', 'B','C'],
                            feedbacks: ['Not that one.<br/>Try again!', 'Not that one.<br/>Try again!', 'Yes! It passes from Oregon to Texas'],
                            "correct-answers": [2],
                            onSelect: _ctx.onAnswerSelected,
                            colorWrong: "transparent",
                            colorRight: "transparent"
                          }, {
                            default: _withCtx(({index, text, selected, color, feedback}) => [
                              _createVNode(_component_flip_transition, {
                                id: text,
                                width: (_ctx.xSmallSize ? `21vw` : `12vw`),
                                height: "9vh",
                                duration: "0.8s",
                                flipBackAfter: 3000,
                                tabindex: "0",
                                role: "button",
                                borderRadius: "5px"
                              }, {
                                front: _withCtx(() => [
                                  _createVNode(_component_image_label, {
                                    id: "front",
                                    "alt-text": _ctx.longAnswers[index],
                                    color: ['rgb(0,180,200)','rgb(255, 110,0)','#f0f'][index],
                                    "background-color": (selected ? `${color}` : '#F0DCB9'),
                                    "background-opacity": 1,
                                    fontSize: "5vh",
                                    fontWeight: "bold",
                                    width: (_ctx.xSmallSize ? `21vw` : `12vw`),
                                    height: "9vh",
                                    border: '1px solid white',
                                    borderRadius: "5px",
                                    onClick: () => { console.log('clicked'); _ctx.quizAnswer = index;}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(text), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["alt-text", "color", "background-color", "width", "onClick"])
                                ]),
                                back: _withCtx(() => [
                                  _createVNode(_component_image_label, {
                                    id: "front",
                                    color: ['rgb(0,180,200)','rgb(255, 110,0)','#f0f'][index],
                                    "background-color": "black",
                                    "background-opacity": 1,
                                    width: (_ctx.xSmallSize ? `21vw` : `12vw`),
                                    height: "9vh",
                                    fontSize: (_ctx.xSmallSize ? `min(2vh,2.5vw)` : `min(1.6vh,1.6vw)`),
                                    fontWeight: "bold",
                                    lineHeight: "(xSmallSize ? `min(2.2vh,2.7vw)` : `min(1.8vh,1.8vw)`)",
                                    border: '1px solid white',
                                    borderRadius: "5px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", { innerHTML: feedback }, null, 8, _hoisted_14)
                                    ]),
                                    _: 2
                                  }, 1032, ["color", "width", "fontSize"])
                                ]),
                                _: 2
                              }, 1032, ["id", "width"])
                            ]),
                            _: 1
                          }, 8, ["preselected", "onSelect"]))
                        : _createCommentVNode("", true),
                      (_ctx.showLinkToPath)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[74] || (_cache[74] = [
                            _createTextVNode(" See NASA's map with the October annular eclipse path "),
                            _createElementVNode("a", {
                              href: "https://science.nasa.gov/eclipses/future-eclipses/eclipse-2023/where-when/",
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }, "here.", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.learnerPath=='Choose')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        (_ctx.queryData)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                              _cache[75] || (_cache[75] = _createTextVNode()),
                              _createVNode(_component_font_awesome_icon, {
                                icon: "play",
                                size: "lg",
                                class: "bullet-icon"
                              }),
                              _cache[76] || (_cache[76] = _createTextVNode(" to \"watch\" the eclipse from the location shared in your link. "))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                          _cache[77] || (_cache[77] = _createTextVNode(" on the map to select any ")),
                          (_ctx.queryData)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "other"))
                            : _createCommentVNode("", true),
                          _cache[78] || (_cache[78] = _createTextVNode(" location and view the eclipse from there. "))
                        ]),
                        _createElementVNode("p", null, [
                          _cache[79] || (_cache[79] = _createElementVNode("strong", null, "Share", -1)),
                          _createTextVNode(" the view from a location by " + _toDisplayString(_ctx.touchscreen ? "tapping" : "clicking") + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "share-nodes",
                            class: "bullet-icon"
                          }),
                          _cache[80] || (_cache[80] = _createTextVNode(" to copy the url. "))
                        ]),
                        _createElementVNode("p", null, [
                          _cache[81] || (_cache[81] = _createTextVNode(" View the eclipse from ")),
                          _cache[82] || (_cache[82] = _createElementVNode("strong", null, "My Location", -1)),
                          _createTextVNode(" by " + _toDisplayString(_ctx.touchscreen ? "tapping" : "clicking") + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "street-view",
                            class: "bullet-icon"
                          }),
                          _cache[83] || (_cache[83] = _createTextVNode(". (Location services must be enabled on device). "))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_icon_button, {
                  "model-value": _ctx.learnerPath == 'Explore',
                  "fa-icon": "rocket",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": 'View eclipse from multiple locations',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false,
                  onActivate: _cache[3] || (_cache[3] = () => { _ctx.learnerPath = 'Explore'})
                }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  "model-value": _ctx.learnerPath == 'Choose',
                  "fa-icon": "location-dot",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": 'Choose any viewing location',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false,
                  onActivate: _cache[4] || (_cache[4] = () => { _ctx.learnerPath = 'Choose'})
                }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  "model-value": _ctx.learnerPath == 'Answer',
                  "fa-icon": "puzzle-piece",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": 'Identify eclipse path',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false,
                  onActivate: _cache[5] || (_cache[5] = () => { _ctx.learnerPath = 'Answer'})
                }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showInfoSheet,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
                  "fa-icon": "book-open",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": _ctx.showInfoSheet ? null : 'More on Eclipses',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false
                }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showWWTGuideSheet,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showWWTGuideSheet) = $event)),
                  "fa-icon": "circle-info",
                  "fa-size": "xl",
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": _ctx.showWWTGuideSheet ? null : 'User Guide',
                  "tooltip-location": 'bottom',
                  "show-tooltip": !_ctx.mobile,
                  "box-shadow": false
                }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_v_hover, null, {
              default: _withCtx(({isHovering, props}) => [
                (false &&!isHovering && !_ctx.smAndUp)
                  ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                      color: "blue",
                      width: '100%'
                    }), {
                      default: _withCtx(() => _cache[84] || (_cache[84] = [
                        _createTextVNode("Tap here to reveal map")
                      ])),
                      _: 2
                    }, 1040))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_slide_y_transition, { disabled: _ctx.smAndUp }, {
                  default: _withCtx(() => [
                    (!_ctx.smAndUp || _ctx.smAndUp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_ctx.learnerPath == 'Explore')
                            ? (_openBlock(), _createBlock(_component_location_selector, {
                                key: 0,
                                "model-value": _ctx.locationDeg,
                                onPlace: _cache[8] || (_cache[8] = (place) => _ctx.updateLocation(place.name)),
                                "detect-location": false,
                                "map-options": _ctx.presetMapOptions,
                                places: _ctx.places,
                                "initial-place": _ctx.places.find(p => p.name === 'selectedLocation'),
                                "place-circle-options": _ctx.placeCircleOptions,
                                "selected-circle-options": _ctx.selectedCircleOptions,
                                selectable: false,
                                class: "leaflet-map"
                              }, null, 8, ["model-value", "map-options", "places", "initial-place", "place-circle-options", "selected-circle-options"]))
                            : _createCommentVNode("", true),
                          (_ctx.learnerPath=='Answer')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[85] || (_cache[85] = [
                                _createElementVNode("img", {
                                  alt: "This is a map of the US with three possible paths for the October 2023 annular eclipse. In choice A, the eclipse moves North to South from Bismarck, ND through Denver, CO and Albuquerque, NM. In choice B, the eclipse moves West to East from Los Angeles, CA to Charlotte, NC. In Choice C, the eclipse moves Northwest to South from Eugene, OR to San Antonio, TX.",
                                  src: _imports_0
                                }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          (_ctx.learnerPath == 'Choose')
                            ? (_openBlock(), _createBlock(_component_location_selector, {
                                key: 2,
                                "model-value": _ctx.locationDeg,
                                "onUpdate:modelValue": _ctx.updateLocationFromMap,
                                "detect-location": false,
                                "map-options": _ctx.userSelectedMapOptions,
                                "selected-circle-options": _ctx.selectedCircleOptions,
                                class: "leaflet-map"
                              }, null, 8, ["model-value", "onUpdate:modelValue", "map-options", "selected-circle-options"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.showGuidedContent]
      ]),
      _createVNode(_component_v_dialog, {
        class: "error-dialog",
        style: _normalizeStyle(_ctx.cssVars),
        modelValue: _ctx.showWebGL2Warning,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => _cache[86] || (_cache[86] = [
              _createElementVNode("div", { class: "error-message" }, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "This app requires WebGL 2")
                ]),
                _createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
                _createElementVNode("p", { class: "mt-2" }, [
                  _createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
                  _createElementVNode("a", {
                    href: "https://get.webgl.org/webgl2/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "here"),
                  _createTextVNode(". ")
                ])
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style", "modelValue"]),
      _createVNode(_component_v_dialog, {
        id: "video-container",
        modelValue: _ctx.showVideoSheet,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
        transition: "slide-y-transition",
        "close-on-back": "",
        fullscreen: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_font_awesome_icon, {
              id: "video-close-icon",
              class: "close-icon",
              icon: "times",
              size: "lg",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showVideoSheet = false)),
              onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
              tabindex: "0"
            }),
            _cache[87] || (_cache[87] = _createElementVNode("video", {
              controls: "",
              id: "info-video"
            }, [
              _createElementVNode("source", {
                src: _imports_1,
                type: "video/mp4"
              })
            ], -1))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        transition: "slide-y-transition",
        modelValue: _ctx.showInfoSheet,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
        class: "bottom-sheet",
        id: "text-bottom-sheet",
        style: _normalizeStyle(_ctx.cssVars)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "bottom-sheet-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { tabindex: "0" }, {
                default: _withCtx(() => _cache[88] || (_cache[88] = [
                  _createElementVNode("h3", { class: "v-btn tab-title" }, "Information", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_font_awesome_icon, {
                id: "close-text-icon",
                class: "control-icon",
                icon: `square-xmark`,
                size: "xl",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showInfoSheet = false)),
                onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.showInfoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { id: "learn-more-content" }, {
                        default: _withCtx(() => [
                          _cache[91] || (_cache[91] = _createElementVNode("div", { id: "info-text-box" }, [
                            _createElementVNode("div", { id: "main-info-text" }, [
                              _createElementVNode("p", null, " Get ready, North America, for not one, but two solar eclipses! On October 14, 2023, North, Central, and South America will be treated to a beautiful annular eclipse. Only 6 months later, on April 8, 2024, an awe-inspiring total solar eclipse will stretch from coast-to-coast across the United States and Canada. "),
                              _createElementVNode("p", null, " This interactive lets you explore the October \"Ring of Fire\" eclipse from different locations. "),
                              _createElementVNode("p", { id: "safety-warning" }, " SAFETY FIRST: NEVER look directly at the Sun without proper eye protection. ")
                            ]),
                            _createElementVNode("div", { id: "FAQ" }, [
                              _createElementVNode("details", null, [
                                _createElementVNode("summary", null, " What causes Solar Eclipses? "),
                                _createElementVNode("p", null, " A solar eclipse happens when the Moon passes between the Earth and the Sun and blocks the Sun from our view. Partial eclipses occur about every 6 months, somewhere on the Earth. The U.S. is lucky to be in the path of the next two solar eclipses. ")
                              ]),
                              _createElementVNode("details", null, [
                                _createElementVNode("summary", null, " Total? Annular? What is the difference?"),
                                _createElementVNode("p", null, [
                                  _createTextVNode(" During a "),
                                  _createElementVNode("strong", null, "total eclipse"),
                                  _createTextVNode(", the Moon covers the entire face of the Sun. Because the Moon doesn't orbit the Earth in a perfect circle, sometimes it is farther away from Earth and appears smaller. When this happens, the Moon doesn't cover the entire face of the Sun. During the eclipse we can still see a bright ring of light around the Moon, sometimes called the \"Ring of Fire.\" This is called an "),
                                  _createElementVNode("strong", null, "annular Eclipse"),
                                  _createTextVNode(". ")
                                ])
                              ]),
                              _createElementVNode("details", null, [
                                _createElementVNode("summary", null, " Why can only some places see the eclipse?"),
                                _createElementVNode("p", null, " An eclipse is caused by the Moon casting a shadow on the Earth. People who are directly behind the Moon will see an annular or total eclipse. As the Moon moves in its orbit around Earth, and as Earth rotates, the location of the shadow will move, sweeping out a path across the surface of the Earth. For a larger number of people who are not directly behind the moon, a smaller amount of the Sun will be blocked, causing a partial eclipse. Even further outside the shadow the Sun will not be blocked at all, and there will be no eclipse visible. "),
                                _createElementVNode("p", null, " The animated figure shows that the Moon's shadow on Earth has two distinct regions. The darker part of the shadow is directly behind the Moon, where people will experience an annular or total eclipse. The lighter part of the shadow falls where people on Earth will see a partial solar eclipse. ")
                              ]),
                              _createElementVNode("details", null, [
                                _createElementVNode("summary", null, "Where can I learn more?"),
                                _createElementVNode("p", null, [
                                  _createTextVNode(" Check out "),
                                  _createElementVNode("a", {
                                    href: "https://science.nasa.gov/eclipses/future-eclipses/eclipse-2023/where-when/",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "NASA's website"),
                                  _createTextVNode(" about the October annular eclipse and Fiske Planetarium's "),
                                  _createElementVNode("a", {
                                    href: "https://www.colorado.edu/fiske/projects/science-through-shadows",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "Science Through Shadows"),
                                  _createTextVNode(" videos. ")
                                ])
                              ])
                            ])
                          ], -1)),
                          _createElementVNode("figure", null, [
                            _createVNode(_component_gif_play_pause, {
                              startPaused: "",
                              gif: require("./assets/eclipse.gif"),
                              still: require("./assets/eclipse_static.gif"),
                              alt: "Animated schematic of a solar eclipse showing how the Moon moves between the Sun and Earth."
                            }, null, 8, ["gif", "still"]),
                            _cache[89] || (_cache[89] = _createElementVNode("figcaption", null, "Image credit: NASA Goddard / Katy Mersmann", -1)),
                            _cache[90] || (_cache[90] = _createElementVNode("div", { class: "disclaimer" }, "Not to scale", -1))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        transition: "slide-y-transition",
        modelValue: _ctx.showWWTGuideSheet,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showWWTGuideSheet) = $event)),
        class: "bottom-sheet",
        id: "wwt-guide-sheet",
        style: _normalizeStyle(_ctx.cssVars)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "bottom-sheet-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { tabindex: "0" }, {
                default: _withCtx(() => _cache[92] || (_cache[92] = [
                  _createElementVNode("h3", { class: "v-btn tab-title" }, "User Guide", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_font_awesome_icon, {
                id: "close-text-icon",
                class: "control-icon",
                icon: `square-xmark`,
                size: "xl",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showWWTGuideSheet = false)),
                onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.showWWTGuideSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { id: "user-guide" }, {
                        default: _withCtx(() => [
                          _cache[128] || (_cache[128] = _createElementVNode("p", {
                            style: {"font-size":"calc(1.1 * var(--default-font-size))"},
                            class: "mb-5"
                          }, " This Data Story allows you to display the October 14, 2023 Annular Eclipse from any location. ", -1)),
                          _createVNode(_component_v_row, { align: "center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_chip, {
                                    label: "",
                                    outlined: ""
                                  }, {
                                    default: _withCtx(() => _cache[93] || (_cache[93] = [
                                      _createTextVNode(" Pan ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "8",
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "W-A-S-D"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                  _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { align: "center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_chip, {
                                    label: "",
                                    outlined: ""
                                  }, {
                                    default: _withCtx(() => _cache[95] || (_cache[95] = [
                                      _createTextVNode(" Zoom ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "8",
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "I-O"), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                  _cache[96] || (_cache[96] = _createElementVNode("br", null, null, -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_26, [
                                    _cache[119] || (_cache[119] = _createElementVNode("h4", { class: "user-guide-header" }, "Time Controls:", -1)),
                                    _cache[120] || (_cache[120] = _createElementVNode("p", { class: "mb-3" }, "(See bottom-left of the screen)", -1)),
                                    _createElementVNode("ul", _hoisted_27, [
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "play",
                                          size: "lg"
                                        }),
                                        _cache[97] || (_cache[97] = _createTextVNode(" to move time forward at 1000x the real speed. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(" If playing, " + _toDisplayString(_ctx.touchscreen ? "tap" : "click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "pause",
                                          size: "lg"
                                        }),
                                        _cache[98] || (_cache[98] = _createTextVNode(" to pause time. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "angle-double-down",
                                          size: "lg"
                                        }),
                                        _cache[99] || (_cache[99] = _createTextVNode(" to decrease speed by 10x. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "angle-double-up",
                                          size: "lg"
                                        }),
                                        _cache[100] || (_cache[100] = _createTextVNode(" to increase speed by 10x. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "rotate",
                                          size: "lg"
                                        }),
                                        _cache[101] || (_cache[101] = _createTextVNode(" to reset time, view, and speed. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _cache[102] || (_cache[102] = _createTextVNode(" You can also control time by dragging ")),
                                        _createVNode(_component_v_icon, {
                                          class: "bullet-icon",
                                          icon: "mdi-circle",
                                          size: "medium"
                                        }),
                                        _cache[103] || (_cache[103] = _createTextVNode(" along the slider. "))
                                      ])
                                    ]),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _cache[121] || (_cache[121] = _createElementVNode("h4", { class: "user-guide-header" }, "Viewing Mode:", -1)),
                                    _cache[122] || (_cache[122] = _createElementVNode("p", { class: "mb-3" }, "(See upper-right of the screen)", -1)),
                                    _createElementVNode("ul", _hoisted_28, [
                                      _cache[112] || (_cache[112] = _createElementVNode("li", { class: "mb-2" }, [
                                        _createTextVNode(" The "),
                                        _createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "selected location"),
                                        _createTextVNode(" and "),
                                        _createElementVNode("span", { style: {"color":"blue","background-color":"white","padding-inline":"0.7em","border-radius":"20px","font-weight":"bold"} }, "date/time"),
                                        _createTextVNode(" are displayed under the map. ")
                                      ], -1)),
                                      _createElementVNode("li", _hoisted_29, [
                                        _createVNode(_component_v_switch, {
                                          class: "display-only-switch",
                                          modelValue: _ctx.displaySwitchOff,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.displaySwitchOff) = $event)),
                                          density: "compact",
                                          "hide-details": "",
                                          disabled: "",
                                          ripple: false,
                                          color: _ctx.accentColor,
                                          "false-icon": "mdi-telescope"
                                        }, null, 8, ["modelValue", "color"]),
                                        _cache[104] || (_cache[104] = _createElementVNode("span", { class: "user-guide-emphasis" }, " Solar Scope:", -1)),
                                        _cache[105] || (_cache[105] = _createTextVNode(" Display zoomed in Sun and Moon as through a dark solar filter or eclipse glasses. "))
                                      ]),
                                      _createElementVNode("li", _hoisted_30, [
                                        _createVNode(_component_v_switch, {
                                          class: "display-only-switch",
                                          modelValue: _ctx.displaySwitchOn,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.displaySwitchOn) = $event)),
                                          density: "compact",
                                          "hide-details": "",
                                          disabled: "",
                                          ripple: false,
                                          color: _ctx.accentColor,
                                          "true-icon": "mdi-image-filter-hdr"
                                        }, null, 8, ["modelValue", "color"]),
                                        _cache[106] || (_cache[106] = _createElementVNode("span", { class: "user-guide-emphasis" }, " Horizon:", -1)),
                                        _cache[107] || (_cache[107] = _createTextVNode(" Display motion of Sun and Moon as they travel through the sky relative to the ground. "))
                                      ]),
                                      _createElementVNode("li", _hoisted_31, [
                                        _createVNode(_component_v_switch, {
                                          class: "display-only-switch",
                                          modelValue: _ctx.displaySwitchOn,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.displaySwitchOn) = $event)),
                                          density: "compact",
                                          "hide-details": "",
                                          disabled: "",
                                          ripple: false,
                                          color: _ctx.accentColor,
                                          "true-icon": "mdi-white-balance-sunny"
                                        }, null, 8, ["modelValue", "color"]),
                                        _cache[108] || (_cache[108] = _createElementVNode("span", { class: "user-guide-emphasis" }, " Track Sun:", -1)),
                                        _cache[109] || (_cache[109] = _createTextVNode(" Always keep camera centered on Sun. "))
                                      ]),
                                      _createElementVNode("li", _hoisted_32, [
                                        _createVNode(_component_v_switch, {
                                          class: "display-only-switch",
                                          modelValue: _ctx.displaySwitchOff,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.displaySwitchOff) = $event)),
                                          density: "compact",
                                          "hide-details": "",
                                          disabled: "",
                                          ripple: false,
                                          color: _ctx.accentColor,
                                          "false-icon": "mdi-image"
                                        }, null, 8, ["modelValue", "color"]),
                                        _cache[110] || (_cache[110] = _createElementVNode("span", { class: "user-guide-emphasis" }, " Don't Track Sun:", -1)),
                                        _cache[111] || (_cache[111] = _createTextVNode(" In Horizon View, show motion of Sun (and Moon) against the sky. "))
                                      ])
                                    ]),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _cache[123] || (_cache[123] = _createElementVNode("h4", { class: "user-guide-header" }, "Display Options:", -1)),
                                    _cache[124] || (_cache[124] = _createElementVNode("p", { class: "mb-3" }, "(See bottom-right of the screen)", -1)),
                                    _cache[125] || (_cache[125] = _createElementVNode("ul", { class: "text-list" }, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Sky Grid:"),
                                        _createTextVNode(" Display altitude/azimuth grid with cardinal directions. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Horizon:"),
                                        _createTextVNode(" Display a virtual \"ground\" that delineates where the Sun rises and sets. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Visible Moon:"),
                                        _createTextVNode(" Solar Eclipses occur during a New Moon, when the Moon is not normally visible in the sky. This option makes it easier to see the Moon against the sky. ")
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Amount Eclipsed:"),
                                        _createTextVNode(" Display percentage of Sun being covered by the Moon. (Disabled when zoomed far out.) ")
                                      ])
                                    ], -1)),
                                    _createVNode(_component_v_divider, {
                                      thickness: "2px",
                                      class: "solid-divider"
                                    }),
                                    _cache[126] || (_cache[126] = _createElementVNode("h4", { class: "user-guide-header" }, "Location Options:", -1)),
                                    _cache[127] || (_cache[127] = _createElementVNode("p", { class: "mb-3" }, "(See top-left of the screen)", -1)),
                                    _createElementVNode("ul", _hoisted_33, [
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "share-nodes",
                                          size: "lg"
                                        }),
                                        _cache[113] || (_cache[113] = _createTextVNode(" to copy ")),
                                        _cache[114] || (_cache[114] = _createElementVNode("strong", null, "share-url", -1)),
                                        _cache[115] || (_cache[115] = _createTextVNode(" for a specific location. "))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                        _createVNode(_component_font_awesome_icon, {
                                          class: "bullet-icon",
                                          icon: "street-view",
                                          size: "lg"
                                        }),
                                        _cache[116] || (_cache[116] = _createTextVNode(" to use the view my ")),
                                        _cache[117] || (_cache[117] = _createElementVNode("strong", null, "My Location", -1)),
                                        _cache[118] || (_cache[118] = _createTextVNode(". (Consult your device's user guide to enable location services.) "))
                                      ])
                                    ])
                                  ]),
                                  _createVNode(_component_v_divider, {
                                    thickness: "2px",
                                    class: "solid-divider"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _cache[129] || (_cache[129] = _createElementVNode("div", { id: "text-credits" }, [
                            _createElementVNode("h3", null, "Credits:"),
                            _createElementVNode("p", { class: "mt-2" }, "This Data Story is powered by WorldWide Telescope (WWT)."),
                            _createElementVNode("p", { class: "my-3" }, "Image of Sun is courtesy of NASA/SDO and the AIA, EVE, and HMI science teams."),
                            _createElementVNode("h4", null, [
                              _createElementVNode("a", {
                                href: "https://www.cosmicds.cfa.harvard.edu/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, "CosmicDS"),
                              _createTextVNode(" Team:")
                            ]),
                            _createTextVNode(" Pat Udomprasert"),
                            _createElementVNode("br"),
                            _createTextVNode(" Jon Carifio"),
                            _createElementVNode("br"),
                            _createTextVNode(" John Lewis"),
                            _createElementVNode("br"),
                            _createTextVNode(" Alyssa Goodman"),
                            _createElementVNode("br"),
                            _createTextVNode(" Mary Dussault"),
                            _createElementVNode("br"),
                            _createTextVNode(" Harry Houghton"),
                            _createElementVNode("br"),
                            _createTextVNode(" Anna Nolin"),
                            _createElementVNode("br"),
                            _createTextVNode(" Evaluator: Sue Sunbury"),
                            _createElementVNode("br"),
                            _createElementVNode("h4", null, [
                              _createElementVNode("a", {
                                href: "https://www.worldwidetelescope.org/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, "WorldWide Telescope"),
                              _createTextVNode(" Team:")
                            ]),
                            _createTextVNode(" Peter Williams"),
                            _createElementVNode("br"),
                            _createTextVNode(" A. David Weigel"),
                            _createElementVNode("br"),
                            _createTextVNode(" Jon Carifio"),
                            _createElementVNode("br")
                          ], -1)),
                          _createVNode(_component_funding_acknowledgment)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_WorldWideTelescope, { "wwt-namespace": _ctx.wwtNamespace }, null, 8, ["wwt-namespace"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            id: "left-buttons-wrapper",
            class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
          }, [
            _createVNode(_component_icon_button, {
              id: "share",
              "fa-icon": "share-nodes",
              color: _ctx.accentColor,
              "focus-color": _ctx.accentColor,
              "box-shadow": false,
              "tooltip-text": "Share view of this location",
              "show-tooltip": !_ctx.mobile,
              onActivate: _ctx.copyShareURL,
              faSize: "1x"
            }, null, 8, ["color", "focus-color", "show-tooltip", "onActivate"]),
            _createVNode(_component_icon_button, {
              id: "my-location",
              "fa-icon": "street-view",
              color: _ctx.accentColor,
              "focus-color": _ctx.accentColor,
              "box-shadow": false,
              "tooltip-text": "Use my location",
              "show-tooltip": !_ctx.mobile,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = (value) => {
            if(value) {
              (_ctx.$refs.geolocation as any).getLocation();
              _ctx.showMyLocationDialog = true;
              _ctx.learnerPath = 'Choose';
            }
            else {
              console.log('geolocation button pressed = false');
            }

          }),
              faSize: "1x"
            }, null, 8, ["color", "focus-color", "show-tooltip"])
          ], 2),
          _createElementVNode("div", {
            id: "location-progress",
            class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
          }, [
            _createVNode(_component_geolocation_button, {
              color: _ctx.accentColor,
              "show-text-progress": true,
              "hide-text": true,
              showCoords: false,
              "hide-button": true,
              requirePermission: false,
              hasPermission: true,
              ref: "geolocation",
              onGeolocation: _cache[24] || (_cache[24] = (loc) => { 
            _ctx.myLocation = {
              latitudeDeg: loc.latitude, 
              longitudeDeg: loc.longitude
            };
            _ctx.selectedLocation = 'My Location';
            _ctx.locationDeg = _ctx.myLocation;
            _ctx.showMyLocationDialog = false;
            }),
              onError: _cache[25] || (_cache[25] = (error) => { 
            _ctx.$notify({
              group: 'geolocation-error',
              title: 'Error',
              text: error.message,
              type: 'error',
            }); 
            _ctx.getMyLocation = false;
            console.log(error);
            })
            }, null, 8, ["color"])
          ], 2)
        ]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_font_awesome_icon, {
                  id: "close-splash-button",
                  onClick: _ctx.closeSplashScreen,
                  icon: "xmark"
                }, null, 8, ["onClick"]),
                _cache[130] || (_cache[130] = _createElementVNode("div", { id: "splash-screen-text" }, [
                  _createElementVNode("p", null, "WATCH the October 14"),
                  _createElementVNode("p", { class: "highlight" }, " Annular Eclipse ")
                ], -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => _cache[131] || (_cache[131] = [
                    _createTextVNode(" Get Started ")
                  ])),
                  _: 1
                }, 8, ["onClick", "color", "density"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[132] || (_cache[132] = _createTextVNode(" Brought to you by ")),
                _cache[133] || (_cache[133] = _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories", -1)),
                _cache[134] || (_cache[134] = _createTextVNode(" and ")),
                _cache[135] || (_cache[135] = _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope", -1)),
                _cache[136] || (_cache[136] = _createTextVNode(". ")),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
                ])
              ])
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_38, _cache[137] || (_cache[137] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.inIntro,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.inIntro) = $event)),
          style: _normalizeStyle(_ctx.cssVars),
          scrim: false,
          persistent: false
        }, {
          default: _withCtx(() => [
            (_ctx.inIntro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.introSlide,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.introSlide) = $event))
                  }, {
                    additional: _withCtx(() => [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_font_awesome_icon, {
                          size: "xl",
                          class: "ma-1",
                          color: "#b3d5e6",
                          icon: "square-xmark",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.inIntro = !_ctx.inIntro)),
                          onKeyup: _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.inIntro = !_ctx.inIntro), ["enter"])),
                          tabindex: "0",
                          "tooltip-location": "start"
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: 1 }, {
                        default: _withCtx(() => _cache[138] || (_cache[138] = [
                          _createElementVNode("div", { class: "intro-text" }, [
                            _createElementVNode("p", { class: "mb-5" }, " On October 14, 2023, the Americas will experience a partial solar eclipse, where the Moon will appear to travel across the Sun and block a portion of it. "),
                            _createElementVNode("p", { class: "mb-5" }, [
                              _createTextVNode(" A lucky segment of the U.S., Central, and South America will experience a dazzling "),
                              _createElementVNode("b", null, "\"Ring of Fire\""),
                              _createTextVNode(" created by an "),
                              _createElementVNode("b", null, "annular eclipse"),
                              _createTextVNode(". ")
                            ]),
                            _createElementVNode("p", { class: "mb-5" }, " Use your detective skills to identify where those lucky people are in our map quiz. ")
                          ], -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 2 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[152] || (_cache[152] = _createElementVNode("p", { class: "mb-3" }, " In this interactive page you can: ", -1)),
                            _createElementVNode("ul", null, [
                              _createVNode(_component_v_list_item, { density: "compact" }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "rocket",
                                    size: "xl",
                                    class: "bullet-icon"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _cache[139] || (_cache[139] = _createElementVNode("strong", null, "Explore", -1)),
                                  _cache[140] || (_cache[140] = _createTextVNode(" what the eclipse will look like from different parts of the U.S. "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, { density: "compact" }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "location-dot",
                                    size: "xl",
                                    class: "bullet-icon"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _cache[141] || (_cache[141] = _createElementVNode("strong", null, "Select any location", -1)),
                                  _cache[142] || (_cache[142] = _createTextVNode(" around the world. See and share how the eclipse would look from there. "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, { density: "compact" }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "puzzle-piece",
                                    size: "xl",
                                    class: "bullet-icon"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _cache[143] || (_cache[143] = _createTextVNode(" Identify the path of the annular eclipse for the U.S. in our ")),
                                  _cache[144] || (_cache[144] = _createElementVNode("strong", null, "Map Quiz", -1)),
                                  _cache[145] || (_cache[145] = _createTextVNode(". "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, { density: "compact" }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "book-open",
                                    size: "xl",
                                    class: "bullet-icon"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _cache[146] || (_cache[146] = _createElementVNode("strong", null, "Learn more", -1)),
                                  _cache[147] || (_cache[147] = _createTextVNode(" about solar eclipses. "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, { density: "compact" }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "circle-info",
                                    size: "xl",
                                    class: "bullet-icon"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _cache[148] || (_cache[148] = _createTextVNode(" Access ")),
                                  _cache[149] || (_cache[149] = _createElementVNode("strong", null, "User Guide", -1)),
                                  _cache[150] || (_cache[150] = _createTextVNode(" on how to navigate this app. "))
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.xSmallSize)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                  _createTextVNode(" To access all features, " + _toDisplayString(_ctx.touchscreen ? "tap" : "click") + " ", 1),
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "circle-chevron-down",
                                    color: "black",
                                    id: "inline-open-icon",
                                    size: "lg"
                                  }),
                                  _cache[151] || (_cache[151] = _createTextVNode(" at top left. "))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", null, [
                      (_ctx.introSlide > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            id: "intro-next-button",
                            color: _ctx.accentColor,
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.introSlide--)),
                            onKeyup: _cache[30] || (_cache[30] = _withKeys(($event: any) => (_ctx.introSlide--), ["enter"])),
                            elevation: "0"
                          }, {
                            default: _withCtx(() => _cache[153] || (_cache[153] = [
                              _createTextVNode(" Back ")
                            ])),
                            _: 1
                          }, 8, ["color"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_btn, {
                      id: "intro-next-button",
                      color: _ctx.accentColor,
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.introSlide++)),
                      onKeyup: _cache[32] || (_cache[32] = _withKeys(($event: any) => (_ctx.introSlide++), ["enter"])),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.introSlide === 1 ? 'Next' : 'Get Started'), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "style"]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_v_chip, {
              "prepend-icon": _ctx.smallSize ? `` : `mdi-map-marker-radius`,
              variant: "outlined",
              size: "small",
              elevation: "2",
              text: _ctx.selectedLocationText,
              onClick: _cache[34] || (_cache[34] = () => {
            _ctx.showGuidedContent = true; 
            _ctx.learnerPath = 'Choose'
            })
            }, null, 8, ["prepend-icon", "text"]),
            _createVNode(_component_v_chip, {
              "prepend-icon": _ctx.smallSize ? `` : `mdi-clock`,
              variant: "outlined",
              size: "small",
              elevation: "2",
              text: _ctx.selectedLocaledTimeDateString
            }, null, 8, ["prepend-icon", "text"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_hover_tooltip, {
              location: "left",
              disabled: _ctx.mobile,
              id: "viewer-mode-switch"
            }, {
              target: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  inset: "",
                  "hide-details": "",
                  ripple: false,
                  modelValue: _ctx.viewerMode,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.viewerMode) = $event)),
                  color: _ctx.accentColor,
                  "false-value": "SunScope",
                  "false-icon": "mdi-telescope",
                  "true-value": "Horizon",
                  "true-icon": "mdi-image-filter-hdr",
                  onKeyup: _cache[36] || (_cache[36] = _withKeys(($event: any) => (_ctx.viewerMode = _ctx.viewerMode === 'SunScope' ? 'Horizon' : 'SunScope'), ["enter"])),
                  tabindex: "0"
                }, null, 8, ["modelValue", "color"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Switch to " + _toDisplayString(_ctx.viewerMode === 'SunScope' ? 'Horizon' : 'Eclipse') + " View ", 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_hover_tooltip, {
                location: "left",
                disabled: _ctx.mobile
              }, {
                target: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    inset: "",
                    "hide-details": "",
                    modelValue: _ctx.toggleTrackSun,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.toggleTrackSun) = $event)),
                    ripple: false,
                    color: _ctx.accentColor,
                    "true-icon": "mdi-white-balance-sunny",
                    "false-icon": "mdi-image",
                    onKeyup: _cache[38] || (_cache[38] = _withKeys(($event: any) => (_ctx.toggleTrackSun = !_ctx.toggleTrackSun), ["enter"])),
                    tabindex: "0"
                  }, null, 8, ["modelValue", "color"])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.toggleTrackSun ? "Don't Track Sun" : 'Center on Sun'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            (_ctx.showEclipsePercentage && _ctx.wwtZoomDeg < 210)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  "prepend-icon": _ctx.smallSize ? `` : `mdi-sun-angle`,
                  variant: "outlined",
                  elevation: "2",
                  text: _ctx.percentEclipsedText
                }, null, 8, ["prepend-icon", "text"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                color: _ctx.accentColor,
                icon: _ctx.showControls ? `chevron-down` : `gear`,
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showControls = !_ctx.showControls)),
                onKeyup: _cache[40] || (_cache[40] = _withKeys(($event: any) => (_ctx.showControls = !_ctx.showControls), ["enter"])),
                tabindex: "0"
              }, null, 8, ["color", "icon"])
            ]),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                (_ctx.showControls)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showAltAzGrid,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.showAltAzGrid) = $event)),
                        onKeyup: _cache[42] || (_cache[42] = _withKeys(($event: any) => (_ctx.showAltAzGrid = !_ctx.showAltAzGrid), ["enter"])),
                        label: "Sky Grid",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.showHorizon,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.showHorizon) = $event)),
                        onKeyup: _cache[44] || (_cache[44] = _withKeys(($event: any) => (_ctx.showHorizon = !_ctx.showHorizon), ["enter"])),
                        label: "Horizon",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        modelValue: _ctx.useRegularMoon,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.useRegularMoon) = $event)),
                        onKeyup: _cache[46] || (_cache[46] = _withKeys(($event: any) => (_ctx.useRegularMoon = !_ctx.useRegularMoon), ["enter"])),
                        label: "Visible Moon",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.accentColor,
                        disabled: _ctx.wwtZoomDeg > 210,
                        modelValue: _ctx.showEclipsePercentage,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.showEclipsePercentage) = $event)),
                        onKeyup: _cache[48] || (_cache[48] = _withKeys(($event: any) => (_ctx.showEclipsePercentage = !_ctx.showEclipsePercentage), ["enter"])),
                        label: "Amount Eclipsed",
                        "hide-details": ""
                      }, null, 8, ["color", "disabled", "modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showVideoSheet,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
              id: "video-icon",
              "fa-icon": "video",
              "fa-size": "lg",
              color: _ctx.accentColor,
              "tooltip-text": "Video guide",
              "tooltip-location": "start",
              "tooltip-offset": _ctx.smallSize ? 0 : '10px'
            }, null, 8, ["modelValue", "color", "tooltip-offset"])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_icon_button, {
                  id: "play-pause-icon",
                  "fa-icon": !(_ctx.playing) ? 'play' : 'pause',
                  onActivate: _cache[50] || (_cache[50] = () => {
                _ctx.playing = !(_ctx.playing);
              }),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "Play/Pause",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  faSize: "1x",
                  "show-tooltip": !_ctx.mobile
                }, null, 8, ["fa-icon", "color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  id: "speed-down",
                  "fa-icon": 'angle-double-down',
                  onActivate: _cache[51] || (_cache[51] = () => {
                    _ctx.speedIndex -= 1;
                    _ctx.playbackRate = Math.pow(10, _ctx.speedIndex);
                    _ctx.playing = true;
                  }),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "10x slower",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  faSize: "1x",
                  "show-tooltip": !_ctx.mobile
                }, null, 8, ["color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  id: "speed-up",
                  "fa-icon": 'angle-double-up',
                  onActivate: _cache[52] || (_cache[52] = () => {
                    _ctx.speedIndex += 1;
                    _ctx.playbackRate = Math.pow(10, _ctx.speedIndex);
                    _ctx.playing = true;
                  }),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "10x faster",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  faSize: "1x",
                  "show-tooltip": !_ctx.mobile
                }, null, 8, ["color", "focus-color", "show-tooltip"]),
                _createVNode(_component_icon_button, {
                  id: "reset",
                  "fa-icon": 'rotate',
                  onActivate: _cache[53] || (_cache[53] = () => {
                    _ctx.selectedTime = 1697292380000;
                    _ctx.speedIndex = 3;
                    _ctx.playbackRate = Math.pow(10, _ctx.speedIndex);
                    _ctx.playing = false;
                    _ctx.toggleTrackSun = true;
                  }),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "Reset",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  faSize: "1x",
                  "show-tooltip": !_ctx.mobile
                }, null, 8, ["color", "focus-color", "show-tooltip"]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[154] || (_cache[154] = _createTextVNode(" Time rate: ")),
                  (_ctx.playbackRate===1 && _ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, " Real time "))
                    : _createCommentVNode("", true),
                  (_ctx.playbackRate!=1 && _ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.playbackRate) + "× ", 1))
                    : _createCommentVNode("", true),
                  (!_ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, " Paused "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_v_slider, {
                id: "slider",
                modelValue: _ctx.selectedTime,
                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.selectedTime) = $event)),
                max: _ctx.maxTime,
                min: _ctx.minTime,
                color: _ctx.accentColor,
                ripple: false,
                "hide-details": "",
                "track-size": "4px",
                "thumb-size": "14px",
                "thumb-label": "always",
                step: _ctx.millisecondsPerInterval,
                onMousedown: _cache[55] || (_cache[55] = () => {_ctx.playing = false;})
              }, {
                "thumb-label": _withCtx((item) => [
                  _createTextVNode(_toDisplayString(_ctx.toTimeString(new Date(item.modelValue))), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "max", "min", "color", "step"]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_icon_button, {
                  "md-icon": "mdi-lock",
                  onActivate: _cache[56] || (_cache[56] = () => _ctx.showPrivacyDialog = true),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "Change privacy settings",
                  "tooltip-location": "bottom",
                  "tooltip-offset": "5px",
                  "show-tooltip": !_ctx.mobile,
                  mdSize: "1em"
                }, null, 8, ["color", "focus-color", "show-tooltip"])
              ])
            ])
          ]),
          (!_ctx.smallSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_dialog, {
          scrim: "false",
          modelValue: _ctx.showPrivacyDialog,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.showPrivacyDialog) = $event)),
          "max-width": "400px",
          id: "privacy-popup-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[155] || (_cache[155] = [
                    _createTextVNode(" To evaluate usage of this app, "),
                    _createElementVNode("strong", null, "anonymized", -1),
                    _createTextVNode(" data may be collected, including locations viewed and map quiz responses. \"My Location\" data is NEVER collected. ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "pt-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "#BDBDBD",
                      href: "https://www.cfa.harvard.edu/privacy-statement",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => _cache[156] || (_cache[156] = [
                        _createTextVNode(" Privacy Policy ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "#ff6666",
                      onClick: _cache[57] || (_cache[57] = () => {
              _ctx.responseOptOut = true;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => _cache[157] || (_cache[157] = [
                        _createTextVNode(" Opt out ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "green",
                      onClick: _cache[58] || (_cache[58] = () => {
              _ctx.responseOptOut = false;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => _cache[158] || (_cache[158] = [
                        _createTextVNode(" Allow ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_notifications, {
          group: "copy-url",
          position: "center top",
          classes: "url-notification"
        }),
        _createVNode(_component_notifications, {
          group: "geolocation-error",
          position: "center top"
        })
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (_ctx.showRating)
            ? (_openBlock(), _createBlock(_component_user_experience, {
                key: 0,
                question: _ctx.question,
                "icon-size": "3x",
                onDismiss: _cache[63] || (_cache[63] = (_rating, _comments) => {
        _ctx.showRating = false;
      }),
                onRating: _cache[64] || (_cache[64] = (rating) => {
        _ctx.currentRating = rating;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
      }),
                onFinish: _cache[65] || (_cache[65] = (rating, comments) => {
        _ctx.currentRating = rating;
        _ctx.currentComments = comments;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
        _ctx.showRating = false;
      })
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_v_btn, {
                      class: "rating-opt-put",
                      color: "#BDBDBD",
                      size: "small",
                      variant: "text",
                      onClick: _cache[60] || (_cache[60] = () => {
              _ctx.showRating = false;
              _ctx.ratingOptOut = true;
            })
                    }, {
                      default: _withCtx(() => _cache[159] || (_cache[159] = [
                        _createTextVNode(" Don't show again ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "privacy-button",
                      color: "#BDBDBD",
                      onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.showRatingPrivacyPolicy = true)),
                      onKeyup: _cache[62] || (_cache[62] = _withKeys(($event: any) => (_ctx.showRatingPrivacyPolicy = true), ["enter"])),
                      size: "small",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => _cache[160] || (_cache[160] = [
                        _createTextVNode(" What is this? ")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["question"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_cds_privacy_policy, {
        modelValue: _ctx.showRatingPrivacyPolicy,
        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.showRatingPrivacyPolicy) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}